
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".2","d":"M16.329 1.466l10.708 18.225a2.78 2.78 0 01-.003 2.846c-.264.449-.645.82-1.104 1.078-.459.257-.979.39-1.508.385H3.008a3.028 3.028 0 01-1.509-.384c-.46-.258-.84-.63-1.105-1.079a2.779 2.779 0 010-2.846L11.101 1.466c.267-.446.65-.816 1.108-1.073a3.08 3.08 0 013.012 0c.459.257.84.627 1.108 1.073z"}}),_c('path',{attrs:{"d":"M13.723 9.98c-.355 0-.653-.115-.894-.345a1.13 1.13 0 01-.361-.852c0-.34.12-.623.36-.853.242-.23.54-.344.895-.344.344 0 .636.115.877.344.24.23.361.514.361.853 0 .339-.12.623-.36.852-.242.23-.534.344-.878.344zm.963 1.196v7.63h-1.96v-7.63h1.96z"}})])
          )
        }
      }
    